export default __webpack_public_path__ + "static/media/active-switch.ce4e1d9e.svg";